module.exports = {
    statusUser:["ACTIVO","NO ACTIVO","BLOQUEADO"]
}